import { APIService } from '../../shared/services/APIService';
import { Diagram } from '../models/Diagram';

export class DiagramService extends APIService {
  async getOneDiagramByName(name: string) {
    const res = await this.http.get<Diagram>('/diagrams/' + name);
    return res.data
  }
}